import React from 'react';
import ReactDOM from 'react-dom/client';

import { App } from './App';

import './locales';
import './index.scss';

/**
 * Находит контейнер `#root` и монтирует в него приложение в режиме StrictMode.
 *
 * @returns {void}
 */
function mountApp(): void {
  const rootElement = document.querySelector('#root');

  if (!(rootElement instanceof HTMLElement)) {
    throw new TypeError('Не найден корневой элемент #root');
  }

  const root = ReactDOM.createRoot(rootElement);

  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}

mountApp();
